<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Kanban components'
 * Name: 'Stage Head'
 * FIGMA: 'https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=3512-44343&m=dev'
 */
import type { KanbanStageHeadProps } from '../types/interfaces'

import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { IconContainer } from '@shared/ui/other'

import { BadgeKanbanStageStatus } from '../../badge-kanban-stage-status'

defineOptions({
  name: 'KanbanStageHead',
})

withDefaults(defineProps<KanbanStageHeadProps>(), {
  href: null,
})
</script>

<template>
  <div class="kanban-stage-head">
    <BadgeKanbanStageStatus
      :text="text"
      :color="color"
    />
    <NuxtLink
      v-if="href"
      :to="href"
      class="kanban-stage-head__count"
      target="_blank"
    >
      {{ cardCount }}
      <IconContainer class="kanban-stage-head__count-icon">
        <FontAwesomeIcon :icon="faArrowUpRight" />
      </IconContainer>
    </NuxtLink>
    <div
      v-else
      class="kanban-stage-head__count"
    >
      {{ cardCount }}
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_kanban-stage-head.scss" />
